<ion-card>
    <!--        <ion-card-content (click)="document.signLater = !document.signLater">-->
    <!--            <ion-label>Tap to sign later...</ion-label>-->
    <!--        </ion-card-content>-->
    <ion-card-content class="less-padding">
        <ion-item>
            <ion-label position="floating">Driver</ion-label>
            <ion-select [(ngModel)]="document.queuedToOperatorId"
                        (ngModelChange)="setOperator($event)" interface="alert">
                <ion-select-option *ngFor="let operator of operatorsList"
                                   [value]="operator.cod">{{operator.username}}</ion-select-option>

            </ion-select>
        </ion-item>
    </ion-card-content>
</ion-card>
